// Only export document settings. Account/model settings never enter this snapshot.
export function buildAntigravityTask({ documentType, folderInfo, layoutMode, tuSoFieldId, health, draft = false }) {
  if (!documentType?.name || !documentType.fields?.length) throw new Error('Chọn mẫu có trường dữ liệu để xuất.');
  if (!folderInfo || !['direct', 'person_folders'].includes(layoutMode)) throw new Error('Chọn nguồn và cấu trúc thư mục trước khi xuất.');
  const fields = documentType.fields.map(({ id, name, field_type, instruction, sort_order }) => ({
    id, name, field_type: field_type || 'text', instruction: instruction || '', sort_order,
  }));
  const names = fields.map(field => field.name);
  if (names.some(name => typeof name !== 'string' || !name.trim()) || new Set(names).size !== names.length) {
    throw new Error('Tên các trường phải có nội dung và không trùng nhau.');
  }
  const tuSoField = tuSoFieldId ? fields.find(field => field.id === tuSoFieldId && field.field_type !== 'document_page_count') : null;
  if (tuSoFieldId && !tuSoField) throw new Error('Chọn lại trường Từ số phù hợp với mẫu hiện tại.');
  const relative = String(folderInfo.relativePath || '').replace(/\\/g, '/');
  if (relative.startsWith('/') || relative.split('/').some(part => part === '..' || part.includes(':'))) throw new Error('Đường dẫn nguồn không hợp lệ.');
  const root = String(health?.hostScanRoot || '');
  // Keep Windows drive/UNC paths intact even when the browser runs on another OS.
  const windows = /^[a-z]:[\\/]|^\\\\/i.test(root);
  const absolute = windows || root.startsWith('/');
  const separator = windows ? '\\' : '/';
  const hostHint = absolute ? root.replace(/[\\/]+$/, '') + (relative ? separator + relative.split('/').join(separator) : separator) : '';
  const scanRoot = String(folderInfo.root || health?.scanRoot || '/scan').replace(/\/+$/, '');
  return {
    format: 'antigravity-document-ocr', version: 1,
    document_type: { id: documentType.id, name: documentType.name, description: documentType.description || '' },
    template_draft: draft,
    template: { name: documentType.name, system_prompt: documentType.system_prompt || '', user_prompt: documentType.user_prompt || '', fields, tu_so_field: tuSoField?.name || '' },
    source: { relative_path: relative, container_path: folderInfo.current || `${scanRoot}/${relative}`.replace(/\/$/, ''), host_path_hint: hostHint, layout: layoutMode },
    pdf_pages: Math.max(1, Math.min(20, Math.trunc(Number(documentType.pdf_extract_pages) || 1))),
  };
}
